module.exports = __webpack_public_path__ + "img/profile-bg.85b35d36.jpg";